<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [noChangeLabel]="true"
  (cancelChange)="cancel()"
  [columns]="[]"
  (submitChange)="save()">
  <ng-container class="content">
    <div class="gFormulaSimilar" *ngIf="GoodsSimilarColumns && GoodsSimilarColumns.length > 0" style="height: 50vh">
      <kgrid
        #goodsSimilar
        id="GoodsSimilar"
        [areaName]="areaName"
        [label]="label"
        [noToolBar]="true"
        [groupable]="false"
        [paging]="false"
        [pagingSize]="1000"
        [gridHeight]="95"
        name="GoodsSimilar"
        [columns]="GoodsSimilarColumns"
        [dataList]="GoodsSimilars"
        (onDelete)="onDeleteGoodsSimilar($event)"
        (onEdit)="onEditGoodsSimilar($event)"
        (onCreate)="onCreateGoodsSimilar($event)"
        aggregatesColumnName="StandardAmount"
        reportName="GoodsSimilar">
      </kgrid>
    </div>
  </ng-container>
</dynamic-form>
